export default {
      id: "icon-chaussure-usage",
      viewBox: "0 0 130.2 87.5",
      url: __webpack_public_path__ + "icons.svg#icon-chaussure",
      toString: function () {
        return this.url;
      }
    }